import React from "react";
import type { FieldErrors, UseFormRegister } from "react-hook-form";
import { Chip, FormFieldHelperText, TextField } from "@c4c-web/ui";
import type { IAddress, TranslationFn } from "../../../types";
import { EAddressType } from "../../../constants";
import { AddressTypeChips } from "./AddressTypeChips";
import { getFormattedAddressType } from "./address-form.helper";

interface IAddressTypeSelectorProps {
  addressType: string[];
  addressTypeError: string;
  errors: FieldErrors<IAddress>;
  formData: IAddress;
  register: UseFormRegister<IAddress>;
  setAddressType: (values: string[]) => void;
  t: TranslationFn;
}

export const AddressTypeSelector: React.FC<IAddressTypeSelectorProps> = ({
  addressType,
  addressTypeError,
  errors,
  formData,
  register,
  setAddressType,
  t,
}) => {
  const { addressLabel, otherAddressType } = formData;
  const formattedAddressType = getFormattedAddressType(addressType);

  return (
    <div className="flex flex-col gap-sm">
      <div className="mt-sm">
        <Chip
          chipItemClassName="border-solid w-full h-[60px]"
          chips={AddressTypeChips(formattedAddressType, t)}
          className="no-scrollbar flex justify-between gap-2xs overflow-x-scroll"
          onSelectionChange={setAddressType}
          selectedValues={formattedAddressType}
          shape="square"
          size="sm"
          variant="outline"
        />
        {addressTypeError ? (
          <FormFieldHelperText error helperText={addressTypeError} />
        ) : null}
      </div>

      {formattedAddressType[0] === EAddressType.OTHER ? (
        <div>
          <TextField
            defaultValue={otherAddressType || addressLabel}
            id="otherAddressType"
            label={t("addressJourney.addressForm.otherAddressType")}
            {...register("otherAddressType", { required: true })}
            error={Boolean(errors.otherAddressType)}
            haveBoldText
            helperText={
              errors.otherAddressType
                ? t("addressJourney.error.otherAddressType")
                : t("addressJourney.addressForm.otherAddressTypePlaceholder")
            }
            placeholder={t(
              "addressJourney.addressForm.placeHolders.otherAddressType",
            )}
          />
        </div>
      ) : null}
    </div>
  );
};
